import { createReducer } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { fetchMasks, fetchedMasks, fetchMask, fetchedMask } from './actions';
import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: [],
  selectedMask: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchMasks, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedMasks, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.data = payload as State['data'];
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(fetchMask, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedMask, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.selectedMask = payload as State['selectedMask'];
        state.error = undefined;
        state.status = 'success';
      }
    })
);
